import React, { useEffect, useState } from "react";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function AdminBotao() {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    let t = "";
    try {
      t = localStorage.getItem("token") || localStorage.getItem("giraia_curso_token") || "";
    } catch (e) {}
    if (!t) return;
    fetch(API + "/auth/me", { headers: { Authorization: "Bearer " + t } })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => {
        const user = u && (u.user || u);
        if (user && (user.role === "admin" || user.role === "diretoria")) setOk(true);
      })
      .catch(() => {});
  }, []);
  if (!ok) return null;
  return <a href="/admin/painel" className="px-3 py-2 rounded-lg bg-[#E2B84A] text-[#141118]">⚙️ Admin</a>;
}
